<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-title">
                            为吸引集聚更多的优秀青年科技人才来蓉创新就业，按照“人才新政3.0版”，对在蓉企业、科研院所新引进的取得博士研究生学历学位的应届毕业生给予生活补贴。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/22/part-2-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        本市行政区域外首次引进的取得全日制博士学历学位应届毕业生（毕业后24个月内引进），到本市企业、科研院所工作并签订3年及以上劳动合同或聘用合同。
                    </div>
                </div>
                <div style="
                            color: #3d5aa3ff;
                            font-size: 0.26rem;
                            text-align: left;
                            line-height: 1.5;
                            margin-top: 0.25rem;
                        ">
                    注：在蓉高校的应届博士毕业生，首次在蓉参加工作并通过单位缴纳社会保险，视为本市行政区域外首次引进的应届博士毕业生
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/22/part-3-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        符合条件的应届博士毕业生，可申请最长3年、最高10万元的博士生活补贴，补贴标准为第一年4万元、第二年3万元、第三年3万元。
                    </div>
                </div>
                <div style="
                            color: #3d5aa3ff;
                            font-size: 0.26rem;
                            text-align: left;
                            line-height: 1.5;
                            margin-top: 0.25rem;
                        ">
                    注：生活补贴每年申请一次，博士在用人单位工作不满12个月的，不享受相应的生活补贴。应届博士生活补贴政策与本市博士后生活资助、安家补贴、优秀海外高校毕业生创新创业补贴政策均不重复享受
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/craft/part-4-title.png" class="part-two-title-img" />
                <div class="main-content">
                    <div class="part-four-items">
                        <div class="title-bg">集中申报</div>
                        <div class="part-four-content1">
                            <p>
                                年度申报通知发放后，由用人单位通过“成都市急需紧缺人才服务管理系统”申报，提供以下相关材料：
                            </p>
                            <p>1．《成都市引进应届博士生活补贴申请表》;</p>
                            <p>
                                2.申报单位为企业的，需提供营业执照原件及复印件；申报单位为科研院所的，需提供《事业单位法人证书》的原件及复印件;
                            </p>
                            <p>
                                3．申请人身份证（护照）、身份证（或护照）、毕业证书、学历学位证书、劳动合同或聘用合同的原件及复印件;
                            </p>
                            <p>
                                4.被引进人才的社保缴纳证明等（劳动合同与社会保险单位名称一致）。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items">
                        <div class="title-bg title-bg2" style="font-size: 0.21rem">
                            区（市）县人力资源和社会保障部门网上初审和现场审核
                        </div>
                    </div>
                    <div class="part-four-items">
                        <div class="title-bg title-bg3">
                            市级有关行业主管部门复核
                        </div>
                        <div class="part-four-content1">
                            <p>
                                区（市）县人力资源和社会保障部门网上初审和现场审核。
                            </p>
                        </div>
                    </div>
                    <div class="part-four-items">
                        <div class="title-bg title-bg4">公示发文</div>
                    </div>
                    <div class="part-four-items" style="border: none">
                        <div class="title-bg title-bg5">资金拨付</div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/label/contact4.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-61888245">028-61888245丶</a>
                            <a href="tel:028-61888121">028-61888121</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市人力资源和社会保障局专业技术人员服务管理处
                    </div>
                </div>
            </div>
            <div class="part-five"></div>
            <!-- <div class="bottom-info">
                责任单位：成都市人力资源和社会保障局专业技术人员服务管理处
            </div>
            <div class="bottom-info" style="margin-top:0.15rem">
                咨询电话：<a href="tel:028-61888245">028-61888245</a>、<a href="tel:028-61888121">028-61888121</a>
            </div> -->
            <!-- <bottom phone="028-61888245" phone2="028-61888121" unit="成都市人力资源和社会保障局专业技术人员服务管理处"></bottom> -->
        </div>
        <call phone="028-61888245"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part3: [
                {
                    id: 1,
                    title: require("../assets/imgs/craft/part3-1.png"),
                    content: "可获一次性2万元奖励",
                    boxHeight: "height:1.45rem",
                },
                {
                    id: 2,
                    title: require("../assets/imgs/craft/part3-2.png"),
                    content: "按规定享受教育优待政策",
                    boxHeight: "height:1.42rem",
                },
                {
                    id: 3,
                    title: require("../assets/imgs/craft/part3-3.png"),
                    content: "凭卡享受医疗、交通、保险、文体娱乐等服务保障",
                    boxHeight: "height:1.42rem",
                },
                {
                    id: 4,
                    title: require("../assets/imgs/craft/part3-4.png"),
                    content:
                        "还可享受人才落户、便捷就医、交通出行、身心健康、保险保障、学习交流等相关政策支持",
                    boxHeight: "height:1.9rem;margin-bottom:0",
                    text: "text-align: left;",
                },
            ],
            part4: [
                {
                    id: 1,
                    title: "title-bg",
                    label: "推荐申报",
                    content1: {
                        title: "单位推荐：",
                        text: `年度申报通知发放后，符合条件的申请人向单位工商注册地的区（市）县人社部门递交以下以下申报材料：
                                1.属自主创业
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                                （2）本人所创办企业的营业执照复印件，完税证明的原件及复印件；
                                （3）身份证、学历学位证书、学历学位鉴定证明、社保卡（带银行金融功能）或银行账户等材料的原件及复印件；`,
                    },
                    content2: {
                        title: "个人申报：",
                        text: `2.属在企业从事相关创新工作
                                （1）《优秀海外高校应届毕业生创新创业补贴申请表》；
                                （2）企业营业执照复印件；
                                （3）本人从事相关创新工作的证明资料；
                                （4）本人身份证、学历学位证书、学历学位鉴定证明（教育部留学服务中心认证的《国外学历学位认证书》、《港澳台学历学位认证书》或四川省人社厅专家服务中心认证的《四川省海外留学人员证书》）、社保卡（带银行金融功能）或银行账户、劳动合同（1年及以上）、社保缴纳证明（6个月及以上）等材料的原件及复印件。`,
                    },
                },
                {
                    id: 2,
                    label: "资格审核",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "所在区（市）县总工会对申报对象进行初审、择优推荐至市总工会。市总工会对单位申报人员进行资格复核",
                    },
                    content2: "",
                    boxHeight: "height:1.79rem",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        height: 7.2rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/22/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;
                padding-bottom: 0.36rem;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.34rem;
                }

                .part-one-text {
                    margin-top: 0.16rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #e8eeff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-two-content {
            margin-top: 1.2rem;
            width: 100%;
            padding: 0.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            line-height: 0.44rem;
            text-align: left;
        }
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;
        padding-bottom: 0.35rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.1rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.5rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;
            padding-bottom: 0.2rem;

            .part-four-items {
                box-sizing: border-box;
                position: relative;
                margin-bottom: 0.15rem;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.2rem 0.25rem 0 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
                padding-bottom: 0.25rem;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.34rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                    white-space: nowrap;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/craft/part4-5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/craft/part4-6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content1 {
                    margin-bottom: 0.2rem;

                    p {
                        margin: 0.01rem;
                    }
                }
            }
        }
    }

    .part-five {
        width: 6.85rem;
        height: 1.17rem;
        background: url(../assets/imgs/22/hint.png);
        background-size: 100% 100%;
        margin: 0 auto;
        margin-top: 0.22rem;
        margin-bottom: 0.32rem;
    }

    .bottom-info {
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;
    }
}
</style>
